export default __webpack_public_path__ + "static/media/ic_gmx_footer.e7821eb2.svg";